import PutSubjectMember from '@Application/Subjects/Members/Commands/PutSubjectMember';
import putSubjectMember from '@Application/Subjects/Members/putSubjectMember';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import PersonRow from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/PersonRow';
import type SubjectUserView from '@UI/Store/Subjects/Views/SubjectUserView';
import { UserPlus } from 'lucide-react';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly candidate: SubjectUserView;
	readonly subject: SubjectAddress;
	readonly facilityId: number;
};

/** A person who can be added to the dossier. Adding gives full access and asks for no confirmation. */
const CandidateRow: React.FC<Props> = ({ candidate, subject, facilityId }) => {
	const dispatch = useDispatch();

	const handleAddClick = React.useCallback(() => {
		dispatch(putSubjectMember(new PutSubjectMember(facilityId, subject, candidate.id, 'full'))).catch(
			ignoreHandledError,
		);
	}, [dispatch, facilityId, subject, candidate.id]);

	return (
		<PersonRow
			initials={`${candidate.firstName.charAt(0)}${candidate.lastName.charAt(0)}`.toUpperCase()}
			seed={candidate.id}
			name={candidate.fullName}
		>
			<Button
				type="button"
				text
				size="sm"
				label="Ajouter"
				icon={<UserPlus size={16} />}
				onClick={handleAddClick}
			/>
		</PersonRow>
	);
};

export default CandidateRow;
